'use client';

import React, { createContext, useContext, ReactNode } from 'react';
import { School } from '@/lib/api/schools';

interface SchoolContextType {
  school: School | null;
}

const SchoolContext = createContext<SchoolContextType | undefined>(undefined);

interface SchoolProviderProps {
  children: ReactNode;
  school: School | null;
}

export function SchoolProvider({ children, school }: SchoolProviderProps) {
  return (
    <SchoolContext.Provider value={{ school }}>
      {children}
    </SchoolContext.Provider>
  );
}

export function useSchool() {
  const context = useContext(SchoolContext);
  if (context === undefined) {
    throw new Error('useSchool must be used within a SchoolProvider');
  }
  return context;
}